import React from 'react';
import { Modal } from 'react-bootstrap';
import PersonalPlayListForm from '../PersonalPlayListForm';

export function PlaylistEditModal({ setModalShow, showModal, handleClose, editPlaylistID, nshowModal, setnModalShow }) {
	return (
		<>
			<Modal show={showModal} onHide={handleClose} className="add__modal">
				<Modal.Header closeButton>
					{editPlaylistID ? <Modal.Title>Edit Playlist</Modal.Title> : <Modal.Title>Add New Playlist</Modal.Title>}
				</Modal.Header>
				<Modal.Body>
					<PersonalPlayListForm
						show={showModal}
						setShow={setModalShow}
						editPlaylistID={editPlaylistID}
						setnModalShow={setnModalShow}
						nshowModal={nshowModal}
					/>
				</Modal.Body>
			</Modal>
		</>
	);
}
